export default "__VITE_ASSET__40a8c58c__"